import api from 'api'
import { CopilotLegalTerms, CopilotLegalTermsStatus } from 'types/CopilotLegalTerms'
import { fetchWithToken } from 'utils'

const fetchAdminCopilotLegalTerms = async (accountKey: string): Promise<CopilotLegalTerms> =>
  fetchWithToken({
    method: 'GET',
    resource: api.adminCopilot,
    path: `accounts/${accountKey}/legal-terms`,
    useV5: false,
    useVersion: 'v1',
  })
    .then((response: Response) => response.json())
    .catch(() => {
      // Something wrong happened during the fetch
      return {
        accountKey: 'accountKey',
        legalTermsStatus: CopilotLegalTermsStatus.DECLINED,
      }
    })

export default fetchAdminCopilotLegalTerms
